import { call, put, takeLatest, select } from 'redux-saga/effects';
import { delay } from 'redux-saga'

import { GET_FESTIVAL_DETAILS, GET_FESTIVALS, ADD_FESTIVAL_TO_FAVORITE, REMOVE_FESTIVAL_FROM_FAVORITE, GET_FESTIVAL_LOCATIONS, GET_EVENTS, ADD_EVENT_TO_FAVORITE, REMOVE_EVENT_FROM_FAVORITE, GET_EVENT_DETAILS } from "../actions/types";
import { showGeneralError, hideGeneralError } from '../actions/general.actions';
import { getFestivalDetailsSucceeded, getFestivalsSucceeded, getFestivalLocationsSucceeded, getEventsSucceeded, getEventDetailsSucceeded } from '../actions/festival.actions';
import { GENERIC_ERROR_MESSAGE} from "../config/messages";
import { getFestivalDetails, getFestivals, addFestivalToFavorite, removeFestivalFromFavorite, getFestivalLocations, getEvents, addEventToFavorite, removeEventFromFavorite, getEventsDetails } from "../api/festival.api";
import { showSpinner, hideSpinner } from '../actions/loading.actions';
import {push} from "connected-react-router";
import {NOT_FOUND_ROUTE} from "../config/routes";


function* getFestivalDetailsSaga(action) {
    try {
        yield put(showSpinner());
        const response = yield call(getFestivalDetails, action.payload);
        if (response.status){
            yield put(hideSpinner());
        }
        if(response.status === 200) {
            yield put(getFestivalDetailsSucceeded(response.data));
        }
    } catch (e) {

        if (e.message.substr(e.message.length - 3) === '404') {
            yield put(push(NOT_FOUND_ROUTE));
        } else {
            yield put(hideSpinner());
            yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
            yield call(delay, 5000);
            yield put(hideGeneralError(''));
        }
    }
}

function* getFestivalsSaga(action) {
    try {
        yield put(showSpinner());
        const response = yield call(getFestivals, action.payload);
        if (response.status){
            yield put(hideSpinner());
        }
        if (response.status === 200) {
            yield put(getFestivalsSucceeded(response.data));
        }
    } catch (e) {
        yield put(hideSpinner());
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000);
        yield put(hideGeneralError(''));
    }
}

function* addFestivalToFavoriteSaga(action) {
    try {
        yield put(showSpinner());
        const response = yield call(addFestivalToFavorite, action.payload);
        if(response.status){
            yield put(hideSpinner());
        }
        if (response.status === 201){
            const prevState = yield select(state => state.festival.festivals);
            let index = prevState.rows.findIndex(element => element.festival_uuid === action.payload);
            prevState.rows[index].favorite.push({uuid: response.data.data.id});      
            const addFestivalToFav = {...prevState}
            yield put(getFestivalsSucceeded(addFestivalToFav))
        }
    } catch(e) {
        yield put(hideSpinner());
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000);
        yield put(hideGeneralError(''));
    }
}

function* removeFestivalFromFavoriteSaga(action) {
    try {
        yield put(showSpinner());
        const response = yield call(removeFestivalFromFavorite, action.payload);
        if(response.status){
            yield put(hideSpinner());
        }
        if (response.status === 204){
            const prevState = yield select(state => state.festival.festivals);
            let index = prevState.rows.findIndex(element => element.festival_uuid === action.festivalId);
            prevState.rows[index].favorite = [];      
            const removeFestivalFromFav = {...prevState}
            yield put(getFestivalsSucceeded(removeFestivalFromFav))
        }
    } catch(e) {
        yield put(hideSpinner());
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000);
        yield put(hideGeneralError(''));
    }
}

function* getFestivalLocationsSaga(action){
    try {
        yield put(showSpinner());
        const response = yield call(getFestivalLocations, action.payload);
        if(response.status){
            yield put(hideSpinner());
        }
        if(response.status === 200) {
            yield put(getFestivalLocationsSucceeded(response.data));
        }
    } catch(e) {
        yield put(hideSpinner());
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000);
        yield put(hideGeneralError(''));
    }
}

function* getEventsSaga(action){
    try {
        yield put(showSpinner());
        const response = yield call(getEvents, action.payload);
        if(response.status){
            yield put(hideSpinner());
        }
        if(response.status === 200) {
            yield put(getEventsSucceeded(response.data));
        }
    } catch(e) {
        yield put(hideSpinner());
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000);
        yield put(hideGeneralError(''));
    }
}

function* addEventToFavoriteSaga(action){
    try {
        yield put(showSpinner());
        const response = yield call(addEventToFavorite, action.payload);
        if(response.status){
            yield put(hideSpinner());
        }
        if (response.status === 201){
            const prevState = yield select(state => state.festival.events);
            let index = prevState.findIndex(element => element.event_uuid === action.payload);
            prevState[index].favorite.push({uuid: response.data.data.id});      
            const addEventToFav = [...prevState]
            yield put(getEventsSucceeded(addEventToFav))
        }
    } catch(e) {
        yield put(hideSpinner());
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000);
        yield put(hideGeneralError(''));
    }
}

function* removeEventFromFavoriteSaga(action) {
    try {
        yield put(showSpinner());
        const response = yield call(removeEventFromFavorite, action.payload.favorite);
        if(response.status){
            yield put(hideSpinner());
        }
        if (response.status === 204){
            const prevState = yield select(state => state.festival.events);
            let index = prevState.findIndex(element => element.event_id === action.payload.event_id);
            prevState[index].favorite = [];      
            const removeEventFromFav = [...prevState]
            yield put(getEventsSucceeded(removeEventFromFav))
        }
    } catch(e) {
        yield put(hideSpinner());
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000);
        yield put(hideGeneralError(''));
    }
}

function* getEventDetailsSaga(action) {
    try {
        yield put(showSpinner());
        const response = yield call(getEventsDetails, action.payload);
        if(response.status){
            yield put(hideSpinner());
        }
        if (response.status === 200){
            yield put(getEventDetailsSucceeded(response.data))
        }
    } catch(e) {
        yield put(hideSpinner());
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000);
        yield put(hideGeneralError(''));
    }
}


export default function* festivalSaga() {
    yield takeLatest(GET_FESTIVAL_DETAILS, getFestivalDetailsSaga);
    yield takeLatest(GET_FESTIVALS, getFestivalsSaga);
    yield takeLatest(ADD_FESTIVAL_TO_FAVORITE, addFestivalToFavoriteSaga);
    yield takeLatest(REMOVE_FESTIVAL_FROM_FAVORITE, removeFestivalFromFavoriteSaga);
    yield takeLatest(GET_FESTIVAL_LOCATIONS, getFestivalLocationsSaga);
    yield takeLatest(GET_EVENTS, getEventsSaga);
    yield takeLatest(ADD_EVENT_TO_FAVORITE, addEventToFavoriteSaga);
    yield takeLatest(REMOVE_EVENT_FROM_FAVORITE, removeEventFromFavoriteSaga);
    yield takeLatest(GET_EVENT_DETAILS, getEventDetailsSaga);
}



// WEBPACK FOOTER //
// ./src/SHARED/sagas/festival.saga.js